import { appSaga } from './app'
import { userSaga } from './user'
import { quoteSaga } from './quote'
import { mtaSaga } from './mta'
import step00SagaWatchers from './quote/step00'
import step02SagaWatchers from './quote/step02'

export default [
    ...appSaga,
    ...userSaga,
    ...quoteSaga,
    ...mtaSaga,
    ...step00SagaWatchers,
    ...step02SagaWatchers,
]



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/index.ts